
	import appconst from '@/lib/appconst'
	export default {
		name: 'pull-refresh',

		props: {
			isios: {
				type: Boolean,
				default: false
			},
			height: {
				type: Number,
				default: 107
			}
		},
		data() {
			return {
				startY: '', //保存touch时的Y坐标
				moveDistance: 0, //保存向下滑动的距离
				moveState: 0, //开始滑动到结束后状态的变化 0:下拉即可刷新 1:释放即可刷新 2:加载中
				duration: 0, //动画持续时间，0就是没有动画


				direction: '' //方向
			}
		},
		computed: {
			style() {
				return {
					transition: `${this.duration}ms`,
					transform: `translate3d(0,${this.direction == 'down' ? '+' : '-'}${this.moveDistance}px, 0)`
				}
			},
		},
		methods: {
			L(value : string, source ?: string, ...argus : string[]) : string {
				if (source) {
					return window.abp.localization.localize(value, source, argus);
				} else {
					return window.abp.localization.localize(value, appconst.localization.defaultLocalizationSourceName, argus);
				}

			},
			touchStart(e) {
				this.duration = 0 // 关闭动画
				this.moveDistance = 0 // 滑动距离归0
				this.startY = e.touches[0].clientY // 获得开始Y坐标
			},
			touchMove(e) { //这里是整个下拉刷新的核心
				let pullpresentbox = document.getElementsByClassName("weui-pull-present-box")[0];
				//首先判断我们有没有滚动条，如果有，我们下拉刷新就不能启用。
				try {
					let move = e.touches[0].clientY - this.startY
					//滑动方向
					if (move > 0) {
						this.direction = "down";
						if (pullpresentbox.scrollTop > 0) return
					} else {
						this.direction = "up";
						if (pullpresentbox.scrollHeight - pullpresentbox.clientHeight > pullpresentbox.scrollTop) return
						//if (pullpresentbox.scrollTop + pullpresentbox.clientHeight != pullpresentbox.scrollHeight) return
					}
					this.moveState = 1
					let absmove = Math.abs(move);
					//判断手指滑动的距离，只有为正数才代表用户下拉了。
					if (absmove > 0) {
						//阻止默认事件，在微信浏览器中尤为有用，至于为什么，你去试就知道了。
						try {
							e.preventDefault()
						} catch (e) {
							//TODO handle the exception
						}

						//增加滑动阻力的感觉
						this.moveDistance = Math.pow(absmove, 0.8);

						if (this.moveDistance > 50) {
							//如果滑动距离大于50 那我就告诉你，释放即可刷新
							if (this.moveState === 1) return
							this.moveState = 1
						} else {
							//否则 恢复原样
							if (this.moveState === 0) return
							this.moveState = 0
						}
					}
				} catch (e) {
					//TODO handle the exception
				}


			},
			touchEnd(e) {
				// 只要手指拿开，我都需要加上结束时的动画，这里为300ms
				this.duration = 300
				if (this.moveDistance > 50) {
					//这里逻辑跟touchMove一样，但是需要真的加载数据了，那moveState变为2 所以加载动画在这出现
					this.moveState = 2
					//因为还没加载完，我得让加载动画显示着，所以这里移动距离为50
					this.moveDistance = 50
					//上拉开始新话题
					if (this.direction == "up") {
						this.moveState = 0
						// this.$emit('refreshup', () => {
						// 	//这里就是成功后的回调了，如果该函数被调用，那就以为着加载数据完成，所以状态要回到0，当然需要在父组件调用。
						// 	this.moveState = 0
						// })
					} else {
						this.$emit('refresh', () => {
							//这里就是成功后的回调了，如果该函数被调用，那就以为着加载数据完成，所以状态要回到0，当然需要在父组件调用。
							this.moveState = 0
						})
					}
				} else {
					//否则 给我老老实实恢复原样
					this.moveDistance = 0
				}
			}
		},
		watch: {
			//这里是给用户操作返回的核心
			moveState(state) {
				//我们监听moveState的状态，
				//0意味着开始也意味着结束，这里是结束，并且只有动画生效我们才能 moveDistance 设为0，
				//为什么动画生效才行，因为动画生效意味着手指离开了屏幕，如果不懂去看touchEnd方法，这时
				//我们让距离变为0才会有动画效果。
				if (state === 0 && this.duration === 300) {
					this.moveDistance = 0
				}
			}
		}
	}
